<template>
  <div class="pad-cycle-lookup-with-id">
    <div class="mb-10 bold-font">Pad Cycle Lookup With ID</div>
    <el-form ref="form" :model="form" label-width="100px" size="small">
      <el-form-item label="Pad Cycle ID">
        <el-input v-model="form.padCycleId" :min="1" class="wp-100"></el-input>
      </el-form-item>
      <div style="text-align: right">
        <el-button
          type="primary"
          size="small"
          @click="searchData"
          :loading="loading"
          >Search</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import swal from 'sweetalert'
import moment from 'moment-timezone'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      form: {
        padCycleId: ''
      },
      loading: false
    }
  },
  methods: {
    validateForm() {
      if (!this.form.padCycleId) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Warning',
          text: 'Please enter pad cycle id'
        })
        return false
      }
      return true
    },
    getSelectedPod(podMac) {
      const matchedPod = this.$store.state.pods.pods.find(
        pod => pod.podId === podMac
      )
      return matchedPod || { podId: podMac }
    },
    searchData() {
      if (this.validateForm()) {
        this.loading = true
        ApiService.GetPadCycleDataWithId(this.form.padCycleId)
          .then(response => {
            this.loading = false
            if (response.data.success) {
              let responseData = response.data.data
              // if no data, the api will return start time and end time as '0001-01-01T00:00:00'
              if (
                !responseData.startTime.includes('0001-01-01') &&
                !responseData.endTime.includes('0001-01-01')
              ) {
                this.$store.commit('pods/SET_SELECTED_DATE', [
                  moment(responseData.startTime, 'YYYY-MM-DDTHH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:s'
                  ),
                  moment(responseData.endTime, 'YYYY-MM-DDTHH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:s'
                  )
                ])
                this.$store.commit(
                  'pods/SET_SELECTED_DATE_QUICK_ACTION',
                  'custom'
                )
                // this.$store.commit(
                //   'pods/SET_SELECTED_UTC_OFFSET',
                //   this.form.utcOffset
                // )
                this.$store.commit(
                  'pods/SET_SELECTED_POD',
                  this.getSelectedPod(responseData.podMac)
                )
              } else {
                swal({
                  icon: 'warning',
                  timer: 2000,
                  title: 'No data was obtained'
                })
              }
            } else {
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed'),
                text: response.data.msg
              })
            }
          })
          .catch(() => {
            this.loading = false
            swal({
              icon: 'error',
              timer: 2000,
              title: 'No data was obtained'
            })
          })
      }
    }
  }
}
</script>

<style lang="scss">
.pad-cycle-lookup-with-id {
  margin-top: 30px;
  border-top: 1px solid #d7d7d7;
  padding-top: 10px;

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    width: 260px;
  }
}
</style>
